/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.Market.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @interface EffectReplay
 */
export interface EffectReplay {
    /**
     * 
     * @type {Array<EffectValues>}
     * @memberof EffectReplay
     */
    'effectValues'?: Array<EffectValues>;
    /**
     * 
     * @type {string}
     * @memberof EffectReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface EffectValues
 */
export interface EffectValues {
    /**
     * 
     * @type {string}
     * @memberof EffectValues
     */
    'EntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EffectValues
     */
    'Code'?: string;
    /**
     * 
     * @type {number}
     * @memberof EffectValues
     */
    'betaCoefficient'?: number;
    /**
     * 
     * @type {number}
     * @memberof EffectValues
     */
    'indexAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EffectValues
     */
    'indexRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof EffectValues
     */
    'lastPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof EffectValues
     */
    'rocDaily'?: number;
    /**
     * 
     * @type {number}
     * @memberof EffectValues
     */
    'rocWeekly'?: number;
    /**
     * 
     * @type {number}
     * @memberof EffectValues
     */
    'rocMonthly'?: number;
    /**
     * 
     * @type {number}
     * @memberof EffectValues
     */
    'rocAnnual'?: number;
    /**
     * 
     * @type {number}
     * @memberof EffectValues
     */
    'rocYtd'?: number;
    /**
     * 
     * @type {number}
     * @memberof EffectValues
     */
    'dividendYield'?: number;
    /**
     * 
     * @type {string}
     * @memberof EffectValues
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface FetchDateReplay
 */
export interface FetchDateReplay {
    /**
     * 
     * @type {Array<MarketSummariesDate>}
     * @memberof FetchDateReplay
     */
    'marketSummariesDate'?: Array<MarketSummariesDate>;
    /**
     * 
     * @type {string}
     * @memberof FetchDateReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface FetchReplay
 */
export interface FetchReplay {
    /**
     * 
     * @type {Array<MarketSummaries>}
     * @memberof FetchReplay
     */
    'marketSummaries'?: Array<MarketSummaries>;
    /**
     * 
     * @type {string}
     * @memberof FetchReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface IndexAnalysisReplay
 */
export interface IndexAnalysisReplay {
    /**
     * 
     * @type {Array<Items>}
     * @memberof IndexAnalysisReplay
     */
    'item'?: Array<Items>;
    /**
     * 
     * @type {string}
     * @memberof IndexAnalysisReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface Indicators
 */
export interface Indicators {
    /**
     * 
     * @type {number}
     * @memberof Indicators
     */
    'fieldId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Indicators
     */
    'fieldName'?: string;
    /**
     * 
     * @type {number}
     * @memberof Indicators
     */
    'currencyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Indicators
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof Indicators
     */
    'average'?: number;
    /**
     * 
     * @type {number}
     * @memberof Indicators
     */
    'last'?: number;
    /**
     * 
     * @type {number}
     * @memberof Indicators
     */
    'max'?: number;
    /**
     * 
     * @type {number}
     * @memberof Indicators
     */
    'min'?: number;
    /**
     * 
     * @type {number}
     * @memberof Indicators
     */
    'order'?: number;
}
/**
 * 
 * @export
 * @interface Items
 */
export interface Items {
    /**
     * 
     * @type {string}
     * @memberof Items
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Items
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Items
     */
    'name'?: string;
    /**
     * 
     * @type {Array<Indicators>}
     * @memberof Items
     */
    'indicators'?: Array<Indicators>;
    /**
     * 
     * @type {Range52w}
     * @memberof Items
     */
    'range52w'?: Range52w;
    /**
     * 
     * @type {number}
     * @memberof Items
     */
    'indexWeight'?: number;
}
/**
 * 
 * @export
 * @interface MarketSummaries
 */
export interface MarketSummaries {
    /**
     * 
     * @type {string}
     * @memberof MarketSummaries
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketSummaries
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketSummaries
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarketSummaries
     */
    'lastDay'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketSummaries
     */
    'lastValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketSummaries
     */
    'rocDaily'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketSummaries
     */
    'rocWeekly'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketSummaries
     */
    'rocMonthly'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketSummaries
     */
    'rocAnnualy'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketSummaries
     */
    'rocYtd'?: number;
}
/**
 * 
 * @export
 * @interface MarketSummariesDate
 */
export interface MarketSummariesDate {
    /**
     * 
     * @type {string}
     * @memberof MarketSummariesDate
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketSummariesDate
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketSummariesDate
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof MarketSummariesDate
     */
    'lastDay'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketSummariesDate
     */
    'lastValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketSummariesDate
     */
    'rocBetweenDate'?: number;
}
/**
 * 
 * @export
 * @interface Range52w
 */
export interface Range52w {
    /**
     * 
     * @type {number}
     * @memberof Range52w
     */
    'low'?: number;
    /**
     * 
     * @type {number}
     * @memberof Range52w
     */
    'high'?: number;
    /**
     * 
     * @type {number}
     * @memberof Range52w
     */
    'last'?: number;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}

/**
 * EffectServiceApi - axios parameter creator
 * @export
 */
export const EffectServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [indexEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketEffectGet: async (identityToken: string, indexEntityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('marketEffectGet', 'identityToken', identityToken)
            const localVarPath = `/market/effect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (indexEntityId !== undefined) {
                localVarQueryParameter['indexEntityId'] = indexEntityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EffectServiceApi - functional programming interface
 * @export
 */
export const EffectServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EffectServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [indexEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketEffectGet(identityToken: string, indexEntityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketEffectGet(identityToken, indexEntityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EffectServiceApi - factory interface
 * @export
 */
export const EffectServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EffectServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [indexEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketEffectGet(identityToken: string, indexEntityId?: string, options?: any): AxiosPromise<EffectReplay> {
            return localVarFp.marketEffectGet(identityToken, indexEntityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EffectServiceApi - object-oriented interface
 * @export
 * @class EffectServiceApi
 * @extends {BaseAPI}
 */
export class EffectServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [indexEntityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EffectServiceApi
     */
    public marketEffectGet(identityToken: string, indexEntityId?: string, options?: AxiosRequestConfig) {
        return EffectServiceApiFp(this.configuration).marketEffectGet(identityToken, indexEntityId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IndexAnalysisServiceApi - axios parameter creator
 * @export
 */
export const IndexAnalysisServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [indexEntityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketIndexanalysisGet: async (identityToken: string, indexEntityId?: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('marketIndexanalysisGet', 'identityToken', identityToken)
            const localVarPath = `/market/indexanalysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (indexEntityId !== undefined) {
                localVarQueryParameter['indexEntityId'] = indexEntityId;
            }

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IndexAnalysisServiceApi - functional programming interface
 * @export
 */
export const IndexAnalysisServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IndexAnalysisServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [indexEntityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketIndexanalysisGet(identityToken: string, indexEntityId?: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndexAnalysisReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketIndexanalysisGet(identityToken, indexEntityId, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IndexAnalysisServiceApi - factory interface
 * @export
 */
export const IndexAnalysisServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IndexAnalysisServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [indexEntityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketIndexanalysisGet(identityToken: string, indexEntityId?: string, culture?: string, options?: any): AxiosPromise<IndexAnalysisReplay> {
            return localVarFp.marketIndexanalysisGet(identityToken, indexEntityId, culture, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IndexAnalysisServiceApi - object-oriented interface
 * @export
 * @class IndexAnalysisServiceApi
 * @extends {BaseAPI}
 */
export class IndexAnalysisServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [indexEntityId] 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndexAnalysisServiceApi
     */
    public marketIndexanalysisGet(identityToken: string, indexEntityId?: string, culture?: string, options?: AxiosRequestConfig) {
        return IndexAnalysisServiceApiFp(this.configuration).marketIndexanalysisGet(identityToken, indexEntityId, culture, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MarketSummaryServiceApi - axios parameter creator
 * @export
 */
export const MarketSummaryServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {boolean} [isGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketMarketsummaryFetchGet: async (identityToken: string, isGlobal?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('marketMarketsummaryFetchGet', 'identityToken', identityToken)
            const localVarPath = `/market/marketsummary-fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isGlobal !== undefined) {
                localVarQueryParameter['isGlobal'] = isGlobal;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {boolean} [isGlobal] 
         * @param {number} [date1] 
         * @param {number} [date2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketMarketsummarydateFetchGet: async (identityToken: string, isGlobal?: boolean, date1?: number, date2?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('marketMarketsummarydateFetchGet', 'identityToken', identityToken)
            const localVarPath = `/market/marketsummarydate-fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isGlobal !== undefined) {
                localVarQueryParameter['isGlobal'] = isGlobal;
            }

            if (date1 !== undefined) {
                localVarQueryParameter['date1'] = date1;
            }

            if (date2 !== undefined) {
                localVarQueryParameter['date2'] = date2;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketSummaryServiceApi - functional programming interface
 * @export
 */
export const MarketSummaryServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketSummaryServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {boolean} [isGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketMarketsummaryFetchGet(identityToken: string, isGlobal?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketMarketsummaryFetchGet(identityToken, isGlobal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {boolean} [isGlobal] 
         * @param {number} [date1] 
         * @param {number} [date2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketMarketsummarydateFetchGet(identityToken: string, isGlobal?: boolean, date1?: number, date2?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchDateReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketMarketsummarydateFetchGet(identityToken, isGlobal, date1, date2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketSummaryServiceApi - factory interface
 * @export
 */
export const MarketSummaryServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketSummaryServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {boolean} [isGlobal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketMarketsummaryFetchGet(identityToken: string, isGlobal?: boolean, options?: any): AxiosPromise<FetchReplay> {
            return localVarFp.marketMarketsummaryFetchGet(identityToken, isGlobal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {boolean} [isGlobal] 
         * @param {number} [date1] 
         * @param {number} [date2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketMarketsummarydateFetchGet(identityToken: string, isGlobal?: boolean, date1?: number, date2?: number, options?: any): AxiosPromise<FetchDateReplay> {
            return localVarFp.marketMarketsummarydateFetchGet(identityToken, isGlobal, date1, date2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarketSummaryServiceApi - object-oriented interface
 * @export
 * @class MarketSummaryServiceApi
 * @extends {BaseAPI}
 */
export class MarketSummaryServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {boolean} [isGlobal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketSummaryServiceApi
     */
    public marketMarketsummaryFetchGet(identityToken: string, isGlobal?: boolean, options?: AxiosRequestConfig) {
        return MarketSummaryServiceApiFp(this.configuration).marketMarketsummaryFetchGet(identityToken, isGlobal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {boolean} [isGlobal] 
     * @param {number} [date1] 
     * @param {number} [date2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketSummaryServiceApi
     */
    public marketMarketsummarydateFetchGet(identityToken: string, isGlobal?: boolean, date1?: number, date2?: number, options?: AxiosRequestConfig) {
        return MarketSummaryServiceApiFp(this.configuration).marketMarketsummarydateFetchGet(identityToken, isGlobal, date1, date2, options).then((request) => request(this.axios, this.basePath));
    }
}



